import React from 'react';
import { Button, Card } from 'antd';

export const IconChip = ({ icon, bg = '#f1f5f9', color = '#94a3b8', size = 40 }) => (
  <div
    style={{
      width: size,
      height: size,
      borderRadius: Math.round(size * 0.22),
      background: bg,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color,
      flexShrink: 0,
      fontSize: Math.round(size * 0.52),
    }}
  >
    {icon}
  </div>
);

const SafetyCard = ({ title, icon, iconBg, iconColor, protectionLevel, onTrigger, triggerLabel, loading, children }) => (
  <Card
    style={{ borderRadius: 12, border: '1px solid #e2e8f0', height: '100%' }}
    styles={{ body: { padding: '16px', display: 'flex', flexDirection: 'column', gap: 12, height: '100%' } }}
  >
    {/* hero icon — primary visual */}
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10, paddingTop: 4 }}>
      <div
        style={{
          width: 72,
          height: 72,
          borderRadius: 18,
          background: iconBg,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: iconColor,
          fontSize: 36,
          border: `1.5px solid ${iconColor}33`,
          boxShadow: `0 4px 14px ${iconColor}22`,
        }}
      >
        {icon}
      </div>

      {/* title below icon */}
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: '#0f172a', lineHeight: 1.4, wordBreak: 'break-word' }}>
          {title}
        </div>
        <span style={{ fontSize: 10, fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
          Protection
        </span>
      </div>
    </div>

    {/* divider */}
    <div style={{ borderTop: '1px solid #f1f5f9' }} />

    {/* protection level badge */}
    {protectionLevel && (
      <div
        style={{
          padding: '4px 10px',
          borderRadius: 6,
          background: '#eff6ff',
          border: '1px solid #bfdbfe',
          display: 'inline-flex',
          alignItems: 'center',
          alignSelf: 'center',
        }}
      >
        <span style={{ fontSize: 11, color: '#2563eb', fontWeight: 600 }}>Level: {protectionLevel}</span>
      </div>
    )}

    {/* controls */}
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8, justifyContent: 'center' }}>
      {children}
    </div>

    {/* trigger button */}
    <Button
      type="primary"
      block
      size="large"
      onClick={onTrigger}
      loading={loading}
      style={{ background: '#2563eb', borderColor: '#2563eb' }}
    >
      {triggerLabel || 'Trigger'}
    </Button>
  </Card>
);

export default SafetyCard;
